module.exports = __webpack_public_path__ + "static/media/gallery_fic.7bdf5308.png";